export default {
  openButton: "Create with AI",
  title: "Quick creation with AI",
  close: "Close",
  descriptors: "Descriptors",
  noDescriptors: "The institution has no descriptors defined for {entity}.",
  // Fallbacks for the institutional alternative names.
  egressProfileLabel: "the Graduate Profile",
  competences: "Competences",
  competenceLabel: "competence",
  alreadyExists: "Already exists",
  remove: "Remove",
  restore: "Add again",
  regenerate: "Regenerate",
  addCompetence: "Add {entity}",
  noType: "No type",
  noCycle: "No cycle",
  themePlaceholder:
    "E.g.: focus on sustainability, innovation, community engagement...",
  themeHint:
    "Optional theme to guide the regeneration (maximum 200 characters).",
  themeInfo:
    "Optional: write keywords or an emphasis to guide the wording of the descriptor or competence; there is no need for long text. E.g.: “technological innovation”, “applied research”, “community engagement”.",
  generating: "Generating content with AI...",
  generateError: "The content could not be generated. Please try again later.",
  cancel: "Cancel",
  confirmSave: "Confirm and save",
  savedToast: "Objects created successfully.",
  saveError:
    "An error occurred while saving the generated objects. Please try again.",
};
